<template>
  <div class="app-main-inner">
    <div class="app-main-inner-row">
      <div class="filters">
        <el-form :inline="true" :label-width="isZh ? '80px' : '125px'" label-position="left">
          <div class="el-form-item-wrapper">
            <el-form-item :label="labelName">
              <!--1-委托单位-->
              <cargo-advance-select
                v-if="criteriaType === 1"
                no="Customer"
                :disabled="locked"
                filterable
                style="width:205px;"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{customer:true, active: true}"
                callback-method-type="value"
                :default-value="criteriaValue"
                :callback-params="{key:'customerId'}"
                @parentCallBack="getValueFromChild"
              />
              <!--2-业务类型-->
              <cargo-advance-select
                v-if="criteriaType === 2"
                no="BusinessType"
                :disabled="locked"
                filterable
                style="width:205px;"
                :tag-name="isZh ? 'chineseName' : 'englishName'"
                tag-value="code"
                :static-options="[...SystemConstants.SE]"
                :default-value="criteriaValue"
                @parentCallBack="getValueFromChild"
              />
              <!--3-货物种类-->
              <cargo-advance-select
                v-if="criteriaType === 3"
                no="CargoType"
                :disabled="locked"
                filterable
                style="width:205px;"
                :select-type="selectTypeNames.basic_data_CargoType"
                :callback-params="{key:'cargoType'}"
                callback-method-type="value"
                :default-value="criteriaValue"
                @parentCallBack="getValueFromChild"
              />
              <!--4-整拼类型-->
              <el-select
                v-if="criteriaType === 4"
                v-model="criteriaValue"
                no="ContainerType"
                :disabled="locked"
                filterable
                style="width:205px;"
                placeholder=""
                @parentCallBack="getValue"
              >
                <el-option
                  v-for="item in containerTypeArrays"
                  :key="item.code"
                  :value="item.code"
                  :label="isZh?item.chineseName:item.englishName"
                />
              </el-select>
              <!--5-起运港（海港）-->
              <cargo-advance-select
                v-if="criteriaType === 5"
                no="SeaPol"
                :disabled="locked"
                filterable
                :select-type="selectTypeNames.basic_data_Seaport"
                :callback-params="{key:'criteriaValue'}"
                callback-method-type="value"
                :clear-not-match="true"
                :default-value="criteriaValue"
                style="width: 100%"
                @parentCallBack="getValueFromChild"
              />
              <!--6-目的港（海港）-->
              <cargo-advance-select
                v-if="criteriaType === 6"
                no="SeaPod"
                :disabled="locked"
                filterable
                :select-type="selectTypeNames.basic_data_Seaport"
                :callback-params="{key:'criteriaValue'}"
                callback-method-type="value"
                :clear-not-match="true"
                :default-value="criteriaValue"
                style="width: 100%"
                @parentCallBack="getValueFromChild"
              />
              <!--7-发货人-->
              <el-input
                v-if="criteriaType === 7"
                v-model="criteriaValue"
                v-uppercase
                no="Shipper"
                :disabled="locked"
                style="width: 286px;"
              />
              <!--8-收货人-->
              <el-input
                v-if="criteriaType === 8"
                v-model="criteriaValue"
                v-uppercase
                no="Consignee"
                :disabled="locked"
                style="width: 286px;"
              />
              <!--9-承运人-->
              <cargo-advance-select
                v-if="criteriaType === 9"
                no="Carrier"
                :disabled="locked"
                filterable
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{seaCmp:true, active: true}"
                :custom-label="(item)=>`${item.chineseName}`"
                :show-custom-label-in-option="true"
                style="width: 205px"
                :default-value="criteriaValue"
                @parentCallBack="getValueFromChild"
              />
              <!--10-订舱代理-->
              <cargo-advance-select
                v-if="criteriaType === 10"
                no="BookingAgent"
                :disabled="locked"
                filterable
                options-width="250px"
                :method-params="{bookingAgent:true, active: true}"
                :select-type="selectTypeNames.basic_data_Company"
                style="width: 205px"
                :default-value="criteriaValue"
                @parentCallBack="getValueFromChild"
              />
              <!--11-航线/区域-->
              <cargo-advance-select
                v-if="criteriaType === 11"
                no="RouteArea"
                :disabled="locked"
                filterable
                :select-type="selectTypeNames.basic_data_Region"
                :callback-params="{key:'region'}"
                callback-method-type="value"
                style="width: 205px"
                :default-value="criteriaValue"
                @parentCallBack="getValueFromChild"
              />
              <!--12-目的港代理-->
              <cargo-advance-select
                v-if="criteriaType === 12"
                no="DesignationAgent"
                :disabled="locked"
                filterable
                tag-name="englishName"
                options-width="250px"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{overseaAgent:true, active: true}"
                style="width: 205px"
                :default-value="criteriaValue"
                @parentCallBack="getValueFromChild"
              />
              <!--13-指定货代理	-->
              <cargo-advance-select
                v-if="criteriaType === 13"
                no="NominatedAgent"
                :disabled="locked"
                filterable
                options-width="250px"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{designationAgent:true, active: true}"
                style="width: 205px"
                :default-value="criteriaValue"
                @parentCallBack="getValueFromChild"
              />
              <!--14-可用分公司	-->
              <cargo-advance-select
                v-if="criteriaType === 14"
                no="AvailableBranch"
                :disabled="locked"
                filterable
                style="width:205px;"
                :select-type="selectTypeNames.basic_data_Office"
                :callback-params="{key:'criteriaValue'}"
                :default-value="criteriaValue"
                :method-params="{}"
                :custom-label="(item)=>`[${item.code}]${isZh ? item.chineseName : item.englishName}`"
                :filter-tag-names="['code', isZh ? 'chineseName' : 'englishName']"
                :show-custom-label-in-option="true"
                @parentCallBack="getValueFromChild"
              />
              <!--15-文件历史	-->
            </el-form-item>
            <el-form-item>
              <el-button no="Add" :disabled="locked" type="primary" @click="add">{{ $t('CargoMsg.Cargo_add') }}</el-button>
              <el-button no="Delete" :disabled="locked" type="danger" @click="remove">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </div>
    <div class="app-main-inner-row row-grid" style="min-height: 400px;">
      <cargo-ag-grid
        config-module="200201"
        :show-side-bar="false"
        :grid-params.sync="gridParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        style="width: 100%;"
      />
    </div>
  </div>
</template>

<script>
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import lodash from 'lodash'
import * as GuaranteeType from '@/class/cargo/model/parameters/GuaranteeType'

export default {
  name: 'GroupTab',
  components: { cargoAdvanceSelect },
  props: {
    groupName: { type: String, required: true }, // 起运港:'POL' , 目的港:'POD' , HSCODE:'HSCODE' , 用户:'USER'
    status: { type: String, required: true },
    detailValue: { type: Array, default: null },
    locked: { type: Boolean, default: false },
    lob: { type: String, default: '' }
  },
  data() {
    return {
      seaPortList: [],
      selectTypeNames: TYPE_NAMES,
      gridParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true,
          suppressMenu: true
        },
        pagination: false
      },
      rowData: [],
      originRowData: [],
      // 委托单位
      customerColumnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_AuthorizedClient'),
          field: 'criteriaValue',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(this.selectTypeNames.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          }
        }
      ],
      // 业务类型
      businessTypeColumnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_BusinessType'),
          field: 'criteriaValue',
          cellRenderer: (params) => {
            return ColumnUtils.jobBussStateLabelFunc(params.value)
          }
        }
      ],
      // 整拼类型
      containerTypeColumnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_FLCLType'),
          field: 'criteriaValue',
          cellRenderer: params => {
            return ColumnUtils.containerLoadTypeLabelFunction(params.data, 'criteriaValue')
          }
        }
      ],
      // 货物种类
      cargoTypeColumnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_TypeOfGoods'),
          field: 'criteriaValue',
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CargoType, 'code', params.value, 'chineseName')
          }
        }
      ],
      // 目的港-海港
      seaPolColumnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_PolSea'),
          field: 'criteriaValue',
          cellRenderer: params => {
            return this.portCellRenderHandler(params.value)
          }
        }
      ],
      // 目的港-海港
      seaPodColumnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_DestinationPortSea'),
          field: 'criteriaValue',
          cellRenderer: params => {
            return this.portCellRenderHandler(params.value)
          }
        }
      ],
      // 可用分公司
      availableColumnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_AvailableBranch'),
          field: 'criteriaValue',
          cellRenderer: params => {
            const officeArr = ColumnUtils.getBasicDataCacheList(TYPE_NAMES.basic_data_Office_All, (item) => item.officeId === Number(params.value))
            return officeArr && officeArr.length > 0 ? `[${officeArr[0].code}]${this.isZh ? officeArr[0].chineseName : officeArr[0].englishName}` : ''
          }
        }
      ],
      shipperColumnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_Shipper'),
          field: 'criteriaValue'
        }
      ],
      consigneeColumnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_Consignee'),
          field: 'criteriaValue'
        }
      ],
      // 承运人
      carrierColumnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_Carrier'),
          field: 'criteriaValue',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(this.selectTypeNames.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          }
        }
      ],
      // 订舱代理
      bookingAgentColumnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_BookingAgent'),
          field: 'criteriaValue',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(this.selectTypeNames.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          }
        }
      ],
      // 航线/区域
      routeAreaColumnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_ShippingRouteArea'),
          field: 'criteriaValue',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(this.selectTypeNames.basic_data_Region, 'code', params.value, 'name')
          }
        }
      ],
      // 目的港代理
      destinationAgentColumnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_DestinationAgent'),
          field: 'criteriaValue',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(this.selectTypeNames.basic_data_Company, 'cmpIdx', Number(params.value), 'englishName')
          }
        }
      ],
      // 海外仓
      overseaWarehouseColumnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_OverseaWarehouse'),
          field: 'criteriaValue',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(this.selectTypeNames.basic_data_OverseaWarehouse, 'warehouseCode', params.value, 'warehouseCode')
          }
        }
      ],
      exchangeAgentColumnDefs: [
        {
          headerName: this.$t('SeaExport.BillExchangeAgent'),
          field: 'criteriaValue',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(this.selectTypeNames.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          }
        }
      ],
      nominatedAgentColumnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_NominatedAgent'),
          field: 'criteriaValue',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(this.selectTypeNames.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          }
        }
      ],
      criteriaValue: '',
      containerTypeArrays: []
    }
  },
  computed: {
    SystemConstants() {
      return SystemConstants
    },
    isZh() {
      return this.$i18n.locale === 'zh'
    },
    columnDefs() {
      switch (this.groupName) {
        case GuaranteeType.CUSTOMER.code:
          return this.customerColumnDefs

        case GuaranteeType.BUSINESS_TYPE.code:
          return this.businessTypeColumnDefs

        case GuaranteeType.CARGO_TYPE.code:
          return this.cargoTypeColumnDefs

        case GuaranteeType.CONTAINER_TYPE.code:
          return this.containerTypeColumnDefs

        case GuaranteeType.SEA_POL.code:
          return this.seaPolColumnDefs

        case GuaranteeType.SEA_POD.code:
          return this.seaPodColumnDefs

        case GuaranteeType.SHIPPER.code:
          return this.shipperColumnDefs

        case GuaranteeType.CONSIGNEE.code:
          return this.consigneeColumnDefs

        case GuaranteeType.CARRIER.code:
          return this.carrierColumnDefs

        case GuaranteeType.BOOKING_AGENT.code:
          return this.bookingAgentColumnDefs

        case GuaranteeType.ROUTE_AREA.code:
          return this.routeAreaColumnDefs

        case GuaranteeType.DESTINATION_AGENT.code:
          return this.destinationAgentColumnDefs

        case GuaranteeType.NOMINATED_AGENT.code:
          return this.nominatedAgentColumnDefs

        case GuaranteeType.AVAILABLE_BRANCH.code:
          return this.availableColumnDefs

        default:
          return []
      }
    },
    labelName() {
      // 1-委托单位,2-业务类型,3-货物种类,4-整拼类型,5-起运港（海港）,6-目的港（海港）,7-发货人,8-收货人,9-承运人,10-订舱代理,11-航线/区域,12-目的港代理,13-指定货代理,14-可用分公司
      switch (this.groupName) {
        case GuaranteeType.CUSTOMER.code:
          return this.$t('CargoMsg.Cargo_AuthorizedClient')

        case GuaranteeType.BUSINESS_TYPE.code:
          return this.$t('CargoMsg.Cargo_BusinessType')

        case GuaranteeType.CARGO_TYPE.code:
          return this.$t('CargoMsg.Cargo_TypeOfGoods')

        case GuaranteeType.CONTAINER_TYPE.code:
          return this.$t('CargoMsg.Cargo_FLCLType')

        case GuaranteeType.SEA_POL.code:
          return this.$t('CargoMsg.Cargo_PortOfLoadingSea')

        case GuaranteeType.SEA_POD.code:
          return this.$t('CargoMsg.Cargo_DestinationPortSea')

        case GuaranteeType.SHIPPER.code:
          return this.$t('CargoMsg.Cargo_Shipper')

        case GuaranteeType.CONSIGNEE.code:
          return this.$t('CargoMsg.Cargo_Consignee')

        case GuaranteeType.CARRIER.code:
          return this.$t('CargoMsg.Cargo_Carrier')

        case GuaranteeType.BOOKING_AGENT.code:
          return this.$t('CargoMsg.Cargo_BookingAgent')

        case GuaranteeType.ROUTE_AREA.code:
          return this.$t('CargoMsg.Cargo_ShippingRouteArea')

        case GuaranteeType.DESTINATION_AGENT.code:
          return this.$t('CargoMsg.Cargo_DestinationAgent')

        case GuaranteeType.NOMINATED_AGENT.code:
          return this.$t('CargoMsg.Cargo_NominatedAgent')

        case GuaranteeType.AVAILABLE_BRANCH.code:
          return this.$t('CargoMsg.Cargo_AvailableBranch')

        default:
          return ''
      }
    },
    criteriaType() {
      // 1-委托单位,2-业务类型,3-货物种类,4-整拼类型,5-起运港（海港）,6-目的港（海港）,7-发货人,8-收货人,9-承运人,10-订舱代理,11-航线/区域,12-目的港代理,13-指定货代理,14-可用分公司
      return GuaranteeType.getTypeByGroupName(this.groupName)
    }
  },
  watch: {
    async status(val) {
      this.created()
    }
  },
  async created() {
    this.rowData = this.detailValue
    this.containerTypeArrays = ChargeUtils.getCargoType(SystemConstants.SE.code)
    this.originRowData = lodash.cloneDeep(this.rowData)
  },
  methods: {
    getValue(obj) {
      this.criteriaValue = obj || ''
    },
    getValueFromChild(obj) {
      this.criteriaValue = obj.value ? obj.value : ''
    },
    add() {
      if (!this.criteriaValue) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PlsInput') + this.labelName)
        return
      }
      const self = this
      const existsRows = this.rowData.filter(row => {
        return String(row.criteriaValue) === String(self.criteriaValue)
      })
      if (existsRows.length > 0) {
        this.$message.error(self.$t('common.tips.repeatedlyTip'))
      } else {
        this.rowData.push({ criteriaValue: this.criteriaValue })
        this.notifyParent()
      }
      this.criteriaValue = ''
    },
    remove() {
      if (this.rowData.length === 0) {
        this.$message.error(this.$t('common.tips.hasOneAtleast'))
        return
      }
      const cell = this.gridOptions.api.getFocusedCell()
      const nodes = this.gridOptions.api.rowModel.rowsToDisplay
      const selectedRow = cell ? nodes.find(node => node.rowIndex === cell.rowIndex).data : null
      if (selectedRow) {
        if (this.criteriaType === 13 && Number(selectedRow.criteriaValue) === this.$store.getters.currentOfficeId) {
          this.$message.error(this.$t('common.tips.cannotDeleteBranch'))
          return
        }
        const index = this.rowData.findIndex(row => row.criteriaValue === selectedRow.criteriaValue)
        if (index > -1) {
          this.rowData.splice(index, 1)
          this.gridOptions.api.refreshCells({ force: true })
          this.notifyParent()
        }
        this.gridOptions.api.clearFocusedCell()
      } else {
        this.$message.error(this.$t('common.tips.hasOneAtleast'))
      }
    },
    // 筛选出新增&和删除项并返还给父组件
    notifyParent() {
      let addRow = []
      if (this.rowData && this.rowData.length > 0) {
        if (this.originRowData && this.originRowData.length > 0) {
          // 原列表没有，但rowData中有的数据，视为新增
          this.rowData.forEach(row => {
            const newRow = this.originRowData.find(originRow => originRow.criteriaValue === row.criteriaValue)
            if (!newRow) {
              addRow.push(row)
            }
          })
        } else {
          addRow = [...this.rowData]
        }
      }
      let delRow = []
      if (this.originRowData && this.originRowData.length > 0) {
        if (this.rowData && this.rowData.length > 0) {
          delRow = this.originRowData.filter(originRow => {
            const rows = this.rowData.filter(row => {
              return originRow.criteriaValue === row.criteriaValue
            })
            return rows.length < 1
          })
        } else {
          delRow = this.originRowData
        }
      }
      const rows = []
      addRow.forEach(row => {
        rows.push({
          criteriaType: this.criteriaType,
          criteriaValue: row.criteriaValue,
          waitDealStatus: 'add'
        })
      })
      delRow.forEach(row => {
        rows.push({
          uuid: row.uuid,
          criteriaType: this.criteriaType,
          criteriaValue: row.criteriaValue,
          waitDealStatus: 'delete'
        })
      })
      this.$emit('func', rows)
    },
    portCellRenderHandler(value) {
      const result = ColumnUtils.resolveColumnLabel(this.selectTypeNames.basic_data_Seaport, 'code', value, 'englishName')
      return result || ''
    }
  }
}
</script>
